import { render, staticRenderFns } from "./modifiedPlastics.vue?vue&type=template&id=ce6b43ee&scoped=true"
import script from "./modifiedPlastics.vue?vue&type=script&lang=js"
export * from "./modifiedPlastics.vue?vue&type=script&lang=js"
import style0 from "./modifiedPlastics.vue?vue&type=style&index=0&id=ce6b43ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6b43ee",
  null
  
)

export default component.exports